module.exports = __webpack_public_path__ + "assets/images/template/project/photo-4-desktop.jpg?v=adc317b2";